import styled from '@emotion/styled'
import { gapY } from '@mobi/component-library/Utils/gap'
import { spacing } from '@mobi/component-library/Theme/Common'

export const AddressManualEntryFieldsetStyled = styled.fieldset(
  {
    display: 'flex',
    flexDirection: 'column',
    border: 'none',
    boxSizing: 'border-box',
    margin: '0 0 0.5rem',
    padding: 0,
  },
  gapY(spacing.sm)
)
